import React, { Component } from "react";
import "../assets/css/reset.css";
import "../assets/css/App.css";
import Header from "./Header";
import DeleteAccountForm from "./DeleteAccountForm";
import DeleteAccountFooter from "./DeleteAccountFooter";
import axios from "../../node_modules/axios";
import CryptoJS from "../../node_modules/crypto-js";
class DeleteAccount extends Component {
  constructor() {
    super();
    this.state = {
      access_token: "",
      password: "",
    };
  }
  componentWillMount() {
    this.getAuthenticate();
  }

  async getAuthenticate() {
    var obj = {
      client_id: "SP_CLIENT_ID",
      client_secret: "SP_CLIENT_SECRET",
      grant_type: "client_credentials",
      resource: "RESOURCE",
      url: "AZURE_TENANT_ID",
    };
    try {
      const response = await axios({
        url: "/authenticate/token",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ access_token: decryptRes.access_token });
      this.fetchCryptPassword();
    } catch (e) {
      console.log(e);
    }
  }

  async fetchCryptPassword() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_DPR_ENCRYPT_PASSWORD",
      request_var: "cryptPassword",
    };
    try {
      const response = await axios({
        url: "clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ password: decryptRes });
    } catch (e) {
      console.log(e);
    }
  }
  render() {
    return (
      <div>
        <Header />
        <main>
          <DeleteAccountForm password={this.state.password} /> 
          <DeleteAccountFooter />
        </main>
      </div>
    ); 
  }
}

export default DeleteAccount;



// WEBPACK FOOTER //
// src/components/DeleteAccount.js